import $ from 'jquery';
import Immutable from 'immutable';
import BasePropertyView from 'BasePropertyView';
import _template from 'properties/table/column-style-button-background.ejs';
import { pickerCfg } from 'pickerCfg.js';
import util from 'util/Util.js';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class StyleButtonBackgroundView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');


        this.events = {
            'change #backgroundColorText, #bgGradientColorText, #mouseOverColorText, #bgGradientOverColorText, #backgroundDownColorText, #bgGradientDownColorText' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #backgroundColor, #bgGradientColor, #mouseOverColor, #bgGradientOverColor, #backgroundDownColor, #bgGradientDownColor' : 'updateColorPicker'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        let oldPropVal;

        if (util.isValidColorcode(propVal)) {
            var colorPicker = propName.replace('Text', '');
            oldPropVal = this.model.get('gridData')[this.colId].attributes[propName];

            let color = this.resolveColor(propVal);

            $('#' + colorPicker).val(color);
            // needs to set to the Column Name for this Column
            this.model.get('gridData')[this.colId].attributes[propName] = color;
            this.render();
        } else {
            this.render();
        }

        // PF-5745
        undoService.add({
            undo: () =>{
                let colorPicker = propName.replace('Text', '');
                let oldColor = this.resolveColor(oldPropVal);

                $('#' + colorPicker).val(oldColor);
                this.model.get('gridData')[this.colId].attributes[propName] = oldColor;
                this.render();
            },
            redo:() => {
                let colorPicker = propName.replace('Text', '');
                let color = this.resolveColor(propVal);

                $('#' + colorPicker).val(color);
                this.model.get('gridData')[this.colId].attributes[propName] = color;
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    updateColorPicker(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.id;
        const propVal  = ev.currentTarget.value;
        let oldPropVal;

        var propTextName = propName + 'Text';

        oldPropVal =this.model.get('gridData')[this.colId].attributes[propName];
        let color = this.resolveColor(propVal);
        $('#' + propTextName).val(color);
        // needs to set to the Column Name for this Column
        this.model.get('gridData')[this.colId].attributes[propName] = color;
        //this.model.trigger('change');

        // PF-5745
        undoService.add({
            undo: () =>{
                let colorPicker = propName.replace('Text', '');
                let oldColor = this.resolveColor(oldPropVal);

                $('#' + colorPicker).val(oldColor);
                this.model.get('gridData')[this.colId].attributes[propName] = oldColor;
                this.render();
            },
            redo:() => {
                let colorPicker = propName.replace('Text', '');
                let color = this.resolveColor(propVal);

                $('#' + colorPicker).val(color);
                this.model.get('gridData')[this.colId].attributes[propName] = color;
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    render() {
        super.render();
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        // Configure color picker.
        //._.forEach(['#backgroundColor', '#bgGradientColor', '#mouseOverColor', '#bgGradientOverColor', '#backgroundDownColor', '#bgGradientDownColor'],
        //.    v => ( $(v).spectrum(pickerCfg) ));

        this.delegateEvents();
        return this;
    }

}

export default StyleButtonBackgroundView;
